// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"f38919a1","199":"4aab441e","453":"cc650920","522":"43f456ca","720":"2d4e86a5","962":"bc917187"}[chunkId] + ".chunk.js";
};